import React, { Component } from "react"
import axios from "axios"
import AxiosConfig from "../../../../../../utilities/AxiosConfig"
import { Button, FormControl, Modal, Spinner } from "react-bootstrap"
import EmployeeDataTypes from "../../../../Types/EmployeeTypes"
import IncidentTypes from "../../../../Types/IncidentTypes"
import DatePicker from "../../../../../../components/common/DatePicker"
import Select from "react-select"
import moment from "moment"
import snackBar from "../../../../../../utilities/snackBar/SnackBar"
import incidentParams from "../IncidentParams"
import "./NewIncident.css"

interface Props {
    toggle: Function
    employee: EmployeeDataTypes
    workCompReference: {
        incidentStatus: Array<{ id: number, text: string }>
        incidentTypes: Array<{ id: number, text: string }>
        states: Array<{ id: number, text: string }>
    }
    refresh: Function
}

interface State {
    eventType: string
    incident: IncidentTypes | {}
    copy: IncidentTypes | {}
    dirty: boolean
    complete: boolean
    discardNag: boolean
    saving: boolean
}

class NewIncident extends Component<Props, State> {

    timeFormat = "YYYY-MM-DD HH:mm:ss"

    state = {
        eventType: "",
        incident: incidentParams,
        copy: incidentParams,
        dirty: false,
        complete: false,
        discardNag: false,
        saving: false,
    }

    componentDidMount() {
        for (const [key] of Object.entries(incidentParams)) {
            incidentParams[key] = null
        }
        this.appendParams([{ IncidentStatusId: 1 }])
        const self = this
        setTimeout(() => {
            self.setState({ incident: JSON.parse(JSON.stringify(incidentParams)), copy: JSON.parse(JSON.stringify(incidentParams)) })
        }, 200)
    }


    setEventType = (s: string) => {
        this.setState({ eventType: s })
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        let incident = this.state.incident
        let eventType = this.state.eventType
        let eventTypes = Object.keys(incident)
        let temp: any = incident
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.appendParams([param])
            }
        }
    }

    appendParams = (params: Array<object>) => {
        for (let i = 0; i < params.length; i++) {
            let key = Object.keys(params[i])
            let value = Object.values(params[i])
            if (value[0] !== "") {
                incidentParams[key[0]] = value[0]
            } else {
                incidentParams[key[0]] = null
            }
        }
        this.setState({ incident: incidentParams })
        this.submitCheck()
    }

    submitCheck = () => {
        if (JSON.stringify(incidentParams) !== JSON.stringify(this.state.copy)) {
            this.setState({ dirty: true })
        } else {
            this.setState({ dirty: false })
        }

        if (incidentParams.IncidentDateUTC
            && incidentParams.IncidentStateId
            && incidentParams.IncidentStatusId
            && incidentParams.IncidentTypeId
        ) {
            this.setState({ complete: true })
        }
    }

    save = () => {
        this.setState({ saving: true })
        let rb: IncidentTypes = incidentParams
        rb.EmployeeId = this.props.employee.UserId
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/CreateFirstWorkCompIncidentPost", rb, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ saving: false })
                this.props.toggle("createNewIncident")
                this.props.refresh()
                if (this.props.employee.FirstName && this.props.employee.LastName) {
                    snackBar({ text: `New Incident Created for ${this.props.employee.FirstName} ${this.props.employee.LastName}`, type: "success", timeout: 3000 })
                } else {
                    snackBar({ text: "New Incident Created", type: "success", timeout: 3000 })
                }
            }).catch(err => {
                this.setState({ saving: false })
                snackBar({ text: "Error creating new incident", type: "error", timeout: 3000 })
                //console.log(err)
            })
    }

    quit = () => {
        if (!this.state.dirty) {
            this.props.toggle("createNewIncident")
        } else {
            this.setState({ discardNag: true })
        }
    }

    back = () => {
        this.setState({ discardNag: false })
    }

    render() {

        // //console.log("Props: ", this.props)
        // //console.log("Params: ", incidentParams)

        return (
            <div className="NewIncident">
                {!this.state.discardNag && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="NewIncidentModalHeader">
                            <span className="material-icons">personal_injury</span>
                            <p>Create a new incident</p>
                            <p>&nbsp;for&nbsp; </p>
                            {this.props.employee.FirstName && this.props.employee.LastName && <p id="new-incident-modal-header-name">{this.props.employee.FirstName} {this.props.employee.LastName}</p>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="NewIncidentModalBody">
                            <div className="NewBasicIncident">
                                <div className="NewBasicIncidentC1">
                                    <p id="new-incident-type-title">Type:</p>
                                </div>
                                <div className="NewBasicIncidentC2">
                                    <div className="HRPillRadiosBtnsWrapper">
                                        {this.props.workCompReference.incidentTypes.map((incidentType) =>
                                            <div className="HRPillRadioBtn" key={`incident-type-btn-${incidentType.id}`} onClick={() => this.appendParams([{ IncidentTypeId: incidentType.id }])}>
                                                <p>{incidentType.text}</p>
                                                {this.state.incident.IncidentTypeId === incidentType.id && <div className="HRPillRadioBtnCustomRadioChecked"></div>}
                                                {this.state.incident.IncidentTypeId !== incidentType.id && <div className="HRPillRadioBtnCustomRadioUnchecked"></div>}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="NewIncidentR2">
                                <div className="NewIncidentDate">
                                    <div className="NewIncidentR2C1">
                                        <p id="new-incident-date-title">Date:</p>
                                    </div>
                                    <div className="NewIncidentR2C2">
                                        <DatePicker value={this.state.incident.IncidentDateUTC || ""} onChange={(val: number) => this.appendParams([{ IncidentDateUTC: moment(val.valueOf()).format().split("T")[0] }])} type="input" useCloseCallback />
                                    </div>
                                    <div className="NewIncidentR2C3">
                                        <p id="new-incident-state-title">State:</p>
                                    </div>
                                    <div className="NewIncidentR2C4">
                                        <Select
                                            options={this.props.workCompReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                                            onChange={(item: any) => {
                                                this.appendParams([{ IncidentStateId: item.value }])
                                            }}
                                            menuPlacement="bottom"
                                            maxMenuHeight={200}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="NewIncidentR3">
                                <div className="NewIncidentR3C1">
                                    <p id="new-incident-status-title">Status:</p>
                                </div>
                                <div className="NewIncidentR3C2">
                                    <Select
                                        //@ts-ignore
                                        value={{ label: this.state.incident.IncidentStatusTypeDesc || "Open" }}
                                        options={this.props.workCompReference.incidentStatus.map((s) => ({ value: s.id, label: s.text }))}
                                        onChange={(item: any) => {
                                            this.appendParams([{ IncidentStatusId: item.value }, { IncidentStatusTypeDesc: item.label }])
                                        }}
                                        menuPlacement="bottom"
                                        maxMenuHeight={200}
                                    />
                                </div>
                            </div>
                            <div className="NewIncidentR4">
                                <div className="NewIncidentR4C1">
                                    <p id="new-incident-claim-num-title">Claim#:</p>
                                </div>
                                <div className="NewIncidentR4C2">
                                    <FormControl onFocus={() => this.setEventType("ClaimNumber")}
                                        placeholder={this.state.incident.ClaimNumber || "Claim Number (Optional)"}
                                        aria-describedby="basic-addon1"
                                        onChange={this.handleChange}
                                        value={this.state.incident.ClaimNumber || ""}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="NewIncidentModalFooter">
                            {!this.state.saving && <Button id="new-incident-cancle-btn" variant="secondary" onClick={() => this.quit()}>Cancel</Button>}
                            <div className="IncidentTypeIcons">
                                {this.state.incident.IncidentTypeId === 1 && <div className="IncidentTypeIconWrapper">
                                    <span className="material-icons">personal_injury</span>
                                </div>}
                                {this.state.incident.IncidentTypeId === 2 && <div className="IncidentTypeIconWrapper">
                                    <span className="material-icons">directions_car</span>
                                </div>}
                                {this.state.incident.IncidentTypeId === 3 && <div className="IncidentTypeIconWrapper">
                                    <span className="material-icons">directions_car</span>
                                    <span className="material-icons">add</span>
                                    <span className="material-icons">personal_injury</span>
                                </div>}
                            </div>
                            {this.state.complete && !this.state.saving && <Button id="new-incident-save-btn" variant="primary" onClick={() => this.save()}>Save</Button>}
                            {!this.state.complete && !this.state.saving && <Button id="new-incident-save-btn" variant="primary" disabled={true}>Save</Button>}
                            {this.state.saving && <Spinner id="new-incident-save-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.discardNag && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="NewIncidentDiscardNagHeader">
                            <p>Discard Changes?</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="NewIncidentDiscardNagBody">
                            <p>All changes will be lost</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="NewIncidentDiscardNagFooter">
                            <Button id="new-incident-discard-nag-discard-btn" variant="danger" onClick={() => this.props.toggle("createNewIncident")}>Discard</Button>
                            <Button id="new-incident-discard-nag-back-btn" variant="secondary" onClick={() => this.back()}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default NewIncident